var React = require('react');

function Diamond (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#933995","fillRule":"evenodd"},React.createElement("g",null,React.createElement("path",{"d":"M8.59.59a2,2,0,0,0-2.83,0L.59,5.76a2,2,0,0,0,0,2.83l5.17,5.17a2,2,0,0,0,2.83,0l5.17-5.17a2,2,0,0,0,0-2.83ZM6.3,3.89V6.58l.4,2.05h1l.4-2.05V3.89ZM7.19,11a.93.93,0,1,0,0-1.86.93.93,0,1,0,0,1.86Z","style":{"fillRule":"evenodd"}}))));
}

Diamond.defaultProps = {"viewBox":"0 0 14.34 14.34"};

module.exports = Diamond;

Diamond.default = Diamond;
